import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFlow} from "../../../../../data/interfaces/iflow.interface";
import * as CapacitorBrowser from "@capacitor/browser";
import * as CapacitorCore from '@capacitor/core';
import {ApiFlowDataService} from "../../../../../data/services/api/flow/api-flow-data.service";
import {Message} from "primeng/api";
import {
  faArrowUpRightFromSquare,
  faCheck,
  faCircleExclamation,
  faCropSimple,
  faGlasses,
  faIdCard,
  faRotateRight,
  faShieldHalved,
  faSun,
  faUserCheck,
  faXmark
} from "@fortawesome/free-solid-svg-icons";
import {ESTADOS_LX} from "../../../../../shared/ui/liga-ui";
import {ITonoMensajeLx, porMensajeLx, tonoMensajeLx} from "../../../../../shared/ui/liga-mensajes";

// Los estilos viven en src/assets/styles/components/_liga-ui.scss (.lx-*) y
// _liga-c.scss (.lxc-*): el build de producción corta en 4 kB por componente.
@Component({
  selector: 'app-ine-validation',
  templateUrl: './ine-validation.component.html',
  styleUrls: ['./ine-validation.component.scss']
})
export class IneValidationComponent implements OnInit {
  responseMessage: Message[] = []
  showMessage = false
  startButtonIsAvailable = false
  @Input() data!: IFlow
  @Input() pushingId: string = ''
  @Output() onEndProcess = new EventEmitter()
  @Output() onUpdateStage = new EventEmitter()
  currentUrl = ''
  startedProcess = false

  // ---------- Solo presentación (estados dentro de la tarjeta) ----------
  // Sin LoaderService: la espera de preparar y de revisar se ve en la pantalla.
  preparando = false
  abriendo = false
  revisando = false
  resultado: '' | 'exito' | 'error' = ''
  readonly estados = ESTADOS_LX
  readonly porMensaje = porMensajeLx
  readonly iconos = {
    ine: faIdCard,
    verificado: faUserCheck,
    abrir: faArrowUpRightFromSquare,
    error: faCircleExclamation,
    listo: faCheck,
    reintentar: faRotateRight,
    seguro: faShieldHalved,
    cerrar: faXmark
  }
  readonly consejos = [
    {icono: faIdCard, texto: 'Tu INE original y vigente'},
    {icono: faSun, texto: 'Buena luz, sin reflejos'},
    {icono: faCropSimple, texto: 'Que se vea completa en la foto'},
    {icono: faGlasses, texto: 'Para la selfie, sin lentes ni gorra'}
  ]

  constructor(
    private flowDataService: ApiFlowDataService
  ) {
  }
  async ngOnInit() {
    await this.getUrl()
  }

  getUrl() {
    this.preparando = true
    this.flowDataService.getIneValidationUrl({idDocument: this.data.id, idStage: this.data.userDocumentId, pushingId: this.pushingId}).subscribe(r => {
      this.preparando = false
      if (!r.error) {
        this.data.userDocumentId = r.data.stageId
        if (r.data.sessionStatus === 'VALIDATED') this.onEndProcess.emit(true)
        else this.onUpdateStage.emit()
        this.currentUrl = r.data.url
        this.startButtonIsAvailable = true
      } else {
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
      }
    })
  }

  closeWindows(w: Window, url: any) {
    this.flowDataService.getIneValidationUrl({idDocument: this.data.id, idStage: this.data.userDocumentId, pushingId: this.pushingId}).subscribe(r => {

      if (!r.error && r.data.sessionStatus === 'VALIDATED') {
        w.close()
        clearInterval(url)
      }
    })
  }

  async openIneValidationUrl(url: string) {
    if (CapacitorCore.Capacitor.getPlatform() === 'web') {
      const incodeWindow = open(
        url,
        'user-validation',
        'width=550,height=700,status=0,toolbar=0'
      );
      if (incodeWindow) {
        const detectsUrl = setInterval( (a  = this) => {
          a.closeWindows(incodeWindow, detectsUrl)
        }, 1000);
      }
    } else {
      await CapacitorBrowser.Browser.open({url})
      /*await CapacitorBrowser.Browser.close().then(r => {
        console.log("url closed")
      })*/
    }
  }

  async start() {
    this.abriendo = true
    await this.openIneValidationUrl(this.currentUrl)
    setTimeout(( ) => {
      this.startedProcess = true
      this.abriendo = false
    }, 2000)

  }
  validateUserIdentity() {
    this.revisando = true
    this.resultado = ''
    this.responseMessage = []
    setTimeout(() => {
      this.flowDataService.validateIneValidationStatus({idDocument: this.data.id, idStage: this.data.userDocumentId, pushingId: this.pushingId}).subscribe(r => {
        this.revisando = false
        this.resultado = r.error ? 'error' : 'exito'
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
        if (!r.error) {
          setTimeout(() => this.terminar(), 2000)
       } else this.onUpdateStage.emit()
      })
    }, 5000)

  }

  // Un solo onEndProcess(true): el regreso automático y «Continuar» de la
  // celebración pasan por aquí (mismo evento, mismos tiempos de antes).
  private finEmitido = false
  terminar() {
    if (this.finEmitido) return
    this.finEmitido = true
    this.onEndProcess.emit(true)
  }

  // ---------- Lectura para la plantilla (sin lógica de negocio) ----------

  get pasoActual(): number {
    return this.startedProcess ? 2 : 1
  }

  get tituloHero(): string {
    if (!this.startedProcess) return 'Verifica tu identidad'
    if (this.resultado === 'exito') return 'Verificamos tu identidad'
    return '¿Ya terminaste tus fotos?'
  }

  get subtituloHero(): string {
    if (!this.startedProcess) return 'Toma fotos de tu INE y una selfie para confirmar que eres tú. Te toma unos minutos.'
    if (this.resultado === 'exito') return 'Ya puedes seguir con tu solicitud.'
    return 'Termina en la ventana de verificación y luego confírmalo aquí.'
  }

  // El botón principal mientras prepara, abre o ya está listo.
  get textoEmpezar(): string {
    if (this.preparando) return 'Preparando tu verificación…'
    if (this.abriendo) return 'Abriendo la verificación…'
    return 'Empezar verificación'
  }

  tono(mensaje: Message): ITonoMensajeLx {
    return tonoMensajeLx(mensaje)
  }

  // Si no se pudo preparar la liga, se vuelve a pedir igual que al entrar.
  reintentarPreparar() {
    this.responseMessage = []
    this.getUrl()
  }
}
